// License expiry date. While the database has no such field, a default value is used.
// When the API starts returning `license_expires` ("YYYY-MM-DD"), nothing else changes.
export const DEFAULT_LICENSE_EXPIRY = "2026-12-31";

/** "2026-12-31" -> "31.12.2026." */
export function formatLicenseDate(iso) {
  const m = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]}.` : "";
}

export function licenseInfo(company, today = new Date()) {
  const iso = company?.license_expires || DEFAULT_LICENSE_EXPIRY;
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  let tone = "ok";
  if (m) {
    const end = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 23, 59, 59);
    const days = Math.ceil((end - today) / 86400000);
    tone = days < 0 ? "expired" : days <= 30 ? "soon" : "ok";
  }
  return { text: formatLicenseDate(iso), tone };
}

export const LICENSE_TONE_CLASS = {
  ok: "text-slate-600 dark:text-slate-300",
  soon: "text-warning-dark dark:text-warning-light",
  expired: "text-danger-dark dark:text-danger-light",
};
